
import { defineComponent, PropType } from 'vue'

import UploadedFile from '@/modules/InvoiceModule/components/UploadedFile/index.vue'

export default defineComponent({
    components: {
        UploadedFile
    },
    props: {
        files: {
            type: Array as PropType<File[]>,
            default: () => []
        }
    }
})
